import React, { Component } from 'react';
import { getAuthInfo } from '../authenticateMessage/service';
import { ldapAuthenticate } from './service';
import { Toast, Form, Input, Button, Dialog, Space, SpinLoading } from 'antd-mobile';
import './index.scss';

class AuthenticateBinding extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cvvName: '',
            cvvNameSecond: '',
            cvvNameThird: '',
            projectId: null,
            userId: null,
            loginCode: null,
            accountId: null,
            phoneSystem: null,
            urlCas: null,
            authFormConfig: {},
            authInformation: {},
            isLoading: true,
        };
    }

    componentDidMount() {
        document.title = '统一身份认证';
        const routeParams = this.parseRouteParams();
        if (/Alipay/i.test(navigator.userAgent)) {
            const script = document.createElement('script');
            script.src = 'https://appx/web-view.min.js';
            document.head.appendChild(script);
        }
        this.setState({
            projectId: routeParams.projectId,
            userId: routeParams.userId,
            loginCode: routeParams.loginCode,
            accountId: routeParams.accountId,
            phoneSystem: routeParams.phoneSystem,
            urlCas: routeParams.urlCas,
        }, () => {
            this.getAuthVerify();
        });
    }

    parseQueryString = (search = window.location.search) => {
        const theRequest = {};
        const query = search.startsWith('?') ? search.slice(1) : search;
        if (!query) return theRequest;
        query.split('&').forEach((item) => {
            const eqIndex = item.indexOf('=');
            if (eqIndex !== -1) {
                theRequest[item.substring(0, eqIndex)] = decodeURIComponent(item.substring(eqIndex + 1));
            }
        });
        return theRequest;
    }

    parseJsonParam = (value) => {
        if (!value) return {};
        try {
            return JSON.parse(value);
        } catch (e) {
            console.error('parse route json param failed', e);
            return {};
        }
    }

    parseRouteParams = () => {
        const theRequest = this.parseQueryString();
        const accountInfo = theRequest.accountInfo
            ? this.parseJsonParam(theRequest.accountInfo)
            : this.parseJsonParam(theRequest.params);
        return {
            projectId: accountInfo.projectId || theRequest.projectId,
            userId: accountInfo.userId || theRequest.userId,
            loginCode: accountInfo.loginCode || accountInfo.token || theRequest.loginCode || theRequest.token,
            accountId: accountInfo.accountId || theRequest.accountId,
            phoneSystem: accountInfo.phoneSystem || theRequest.phoneSystem,
            urlCas: accountInfo.urlCas || theRequest.urlCas,
        };
    }

    getMissingRouteParams = (routeParams) => {
        const missing = [];
        if (!routeParams.projectId) missing.push('projectId');
        if (!routeParams.userId) missing.push('userId');
        if (!routeParams.loginCode) missing.push('loginCode');
        if (!routeParams.accountId) missing.push('accountId');
        return missing;
    }

    parseAuthFormConfig = (data = {}) => {
        let config = { ...data };
        if (data.json) {
            try {
                const jsonData = typeof data.json === 'string' ? JSON.parse(data.json) : data.json;
                config = { ...config, ...jsonData };
            } catch (e) {
                console.error('parse auth json failed', e);
            }
        }
        return config;
    }

    getAuthVerify = () => {
        const { projectId, userId, loginCode, accountId, phoneSystem } = this.state;
        const params = { projectId, userId, loginCode, accountId };
        if (phoneSystem) {
            params.phoneSystem = phoneSystem;
        }
        getAuthInfo(params).then(res => {
            if (res.errorCode == 0) {
                const authConfig = this.parseAuthFormConfig(res.data);
                this.setState({
                    authInformation: res.data,
                    authFormConfig: authConfig,
                    urlCas: authConfig.verifyUrl || authConfig.urlCas || this.state.urlCas,
                    isLoading: false,
                });
                if (window?.my) {
                    window.my.postMessage({ sendToMiniProgram: document.title });
                }
            } else {
                Toast.show({ content: res.errorMessage, position: 'bottom' });
                this.setState({ isLoading: false });
            }
        });
    }

    goResultPage = (isSuccess, message) => {
        const query = `isSuccess=${isSuccess ? 1 : 0}&message=${encodeURIComponent(message)}`;
        window.location.replace(`/authenticateBindingSuccess?${query}`);
    }

    onSubmitBinding = (value) => {
        const { projectId, accountId, urlCas } = this.state;
        const { cvvName, cvvNameSecond } = value;
        const params = {
            accountId: Number(accountId),
            projectId: Number(projectId),
            username: cvvName,
            password: cvvNameSecond,
        };
        ldapAuthenticate(urlCas,params).then(res => {
            if (res.errorCode == 200) {
                this.goResultPage(true, res.message || '恭喜你，完成了身份认证，点击完成返回');
            } else {
                Toast.show({ content: res.message || '认证失败', position: 'bottom' });
            }
        }).catch(() => {
            Toast.show({ content: '认证请求失败，请稍后重试', position: 'bottom' });
        });
    }

    isSubmitDisabled = () => {
        const { cvvName, cvvNameSecond, cvvNameThird, authFormConfig } = this.state;
        if (authFormConfig.cvvName && !String(cvvName || '').trim()) return true;
        if (authFormConfig.cvvNameSecond && !String(cvvNameSecond || '').trim()) return true;
        if (authFormConfig.cvvNameThird && !String(cvvNameThird || '').trim()) return true;
        return false;
    }

    onFormValuesChange = (_, allValues) => {
        this.setState({
            cvvName: allValues.cvvName || '',
            cvvNameSecond: allValues.cvvNameSecond || '',
            cvvNameThird: allValues.cvvNameThird || '',
        });
    }

    render() {
        const onSubmit = (value) => {
            Dialog.confirm({
                title: '提示',
                content: '是否提交当前认证信息',
                onConfirm: async () => {
                    await this.onSubmitBinding(value);
                    return true;
                },
            });
        };
        const { authFormConfig } = this.state;

        return (
            <>
                {!this.state.isLoading ? (
                    <div className="card-recharge-page">
                        <Form
                            layout="horizontal"
                            onFinish={onSubmit}
                            onValuesChange={this.onFormValuesChange}
                            validateTrigger="onSubmit"
                            footer={
                                <>
                                    <div className="card-recharge-footer auth-tips">
                                        <span className="footer-babel">温馨提示：</span>
                                        <p>{authFormConfig.remark}</p>
                                    </div>
                                    <Button
                                        block
                                        type="submit"
                                        color="primary"
                                        disabled={this.isSubmitDisabled()}
                                        style={{
                                            background: this.isSubmitDisabled() ? '#D6D6D6' : '#5ABDFC',
                                        }}
                                        size="large"
                                    >
                                        提交
                                    </Button>
                                </>
                            }
                        >
                            {authFormConfig.cvvName ? (
                                <Form.Item
                                    label={authFormConfig.cvvName}
                                    name="cvvName"
                                    rules={[{ required: true, message: `请输入${authFormConfig.cvvName}` }]}
                                >
                                    <Input
                                        style={{ '--text-align': 'right' }}
                                        type='text'
                                        placeholder={authFormConfig.cvvPrompt}
                                        clearable
                                    />
                                </Form.Item>
                            ) : null}
                            {authFormConfig.cvvNameSecond ? (
                                <Form.Item label={`${authFormConfig.cvvNameSecond}：`}
                                    rules={[{ required: true, message: `请输入${authFormConfig.cvvPromptSecond}` }]}
                                    name="cvvNameSecond">
                                    <Input
                                        style={{ '--text-align': 'right' }}
                                        type="password"
                                        placeholder={authFormConfig.cvvPromptSecond}
                                        clearable
                                    />
                                </Form.Item>
                            ) : null}
                            {authFormConfig.cvvNameThird ? (
                                <Form.Item
                                    label={authFormConfig.cvvNameThird}
                                    name="cvvNameThird"
                                    rules={[{ required: true, message: `请输入${authFormConfig.cvvNameThird}` }]}
                                >
                                    <Input
                                        style={{ '--text-align': 'right' }}
                                        placeholder={authFormConfig.cvvPromptThird}
                                        clearable
                                    />
                                </Form.Item>
                            ) : null}
                        </Form>
                    </div>
                ) : (
                    <div className="page-loading">
                        <Space direction="horizontal" wrap block style={{ '--gap': '16px' }}>
                            <SpinLoading color="primary" />
                        </Space>
                    </div>
                )}
            </>
        );
    }
}

export default AuthenticateBinding;
